import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';

@Component({
  selector: 'ndms-time',
  templateUrl: './ndms-time.component.html',
  styleUrls: ['./ndms-time.component.scss']
})
export class NdmsTimeComponent extends NdmsFormControlComponent implements OnInit {

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  ngOnInit() {
  }

}
